import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";

import LookMainHeaderCloseButton from "../lookMainHeaderCloseButton";
import LookViewTypeSwitcher from "../lookViewTypeSwitcher";
import {setWizardActiveStep} from "../../../../../actions/wizardFunctions";
import LookWizardHeaderTitleAndBackButton from "./LookWizardHeaderTitleAndBackButton";

const LookWizardHeader = (props) => {

  const {isMobile, setWizardActiveStep, wizardActiveItem} = props;

  return (
    <Fragment>
      <LookWizardHeaderTitleAndBackButton/>
      <div className="lm-header__buttons">
        {isMobile && wizardActiveItem ? (
          <Button className={"look-button look-button--primary look-button--no-radius lm-header__buttons-full-button"}
                  onClick={() => setWizardActiveStep(0)}>
            <FormattedMessage id="iconButton.edit"/> {wizardActiveItem.name}
          </Button>
        ) : (
          <Fragment>
            <LookViewTypeSwitcher isWizard={true}/>
            <LookMainHeaderCloseButton/>
          </Fragment>
        )}
      </div>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {wizardActiveItem} = store.wizardState;
  return {
    isMobile,
    wizardActiveItem,
  };
};

const mapDispatchToProps = {
  setWizardActiveStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookWizardHeader)
